<title>{{ ndcVoucherLogsPage.htmlTitle }}</title>
<app-banner [banner]="ndcVoucherLogsPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div class="d-flex container-fluid p-0 apiContainer" id="wrapper">
  <app-left-side-menu-admin-control></app-left-side-menu-admin-control>
  <div class="apiContainerRight">
    <div id="errorpn-VoucherRedeem" *ngIf="downloadError">      
      <div id="errDet" class="err-VoucherRedeem">
        {{ downloadError }}
      </div>      
    </div>
    <div id="errorpn-VoucherRedeem" *ngIf="accessError">
      <div id="errDet" class="err-VoucherRedeem">
        {{ accessError }}
      </div>      
    </div>
    <br />
    <br />
    <div *ngIf="isAdmin()" class="ms-4 commonFormsCss voucherLog">
      <b>Select form to download</b>
      <form [formGroup]="voucherLogsForm">
        <div class="form-group">
          <div class="pt-2"><input type="radio" name="formType" class="me-2" checked="" value="issueVoucher" formControlName="formType" (change)="clearValidationError()"/>Issue Voucher</div>
          <div class="pt-2"><input type="radio" name="formType" class="radio-margin" value="redeemVoucher" formControlName="formType" (change)="clearValidationError()"/> Redeem voucher</div>
        </div>
        <div class="pt-3">
          <b>Select date range</b>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-sm-6">
                  <span class="sml">Start Date</span><br />
                  <input
                    id="bkdate"
                    class="form-control start-date"
                    name="bkdate"
                    type="date"
                    placeholder="dd-mm-yyyy"
                    formControlName="startDate"
                    [max]="getToday()"
                    (change)="clearValidationError()"
                  />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && voucherLogsForm.get('startDate')?.errors">Please select start date</div>
                </div>
                <div class="col-sm-6">
                  <span class="sml">End Date</span><br />
                  <input id="bkdate" class="form-control start-date" name="bkdate" type="date" placeholder="dd-mm-yyyy" formControlName="endDate" (change)="clearValidationError()" />
                  <div class="field-validation-valid text-danger" *ngIf="submitted && voucherLogsForm.get('endDate')?.errors">Please select end date</div>
                  <div class="ms-2 field-validation-valid text-danger" *ngIf="invalidEndDate">End date must be after the start date</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-sm-6"><button type="button" class="btn btn-lg btnblu" (click)="downloadCsv()">Get CSV</button></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
